<template>
    <router-link :to="{name: 'groups.show', params: { group_slug: group.slug } }" class="nav-item group-item">
        <div class="group-image">
            <img :src="`${ group.image }?width=60`" alt="" onerror="this.src='/img/image.resized.jpg?width=60'">
        </div>
        <div class="group-name">
            {{ group.name }}
            <span class="notification-count hidden notification-badge" :data-notify-id="'groups.boards.' + group.slug"></span>
        </div>
    </router-link>
</template>
<script>
    import Global from '../../../mixins/Global';

    export default {
        name: 'NavBoard',

        mixins: [Global],

        props: {
            group: {
                required: true,
                type: Object,
            },
        },
    };
</script>

<style lang="scss" scoped>
    .nav-item {
        .group-image {
            @apply tw-rounded-full tw-overflow-hidden tw-mr-3;
            width: 25px;
            height: 25px;

            img {
                width: 25px;
                height: 25px;
                object-fit: cover;
            }
        }

        .group-name {
            @apply tw-pt-1 tw-flex-1 tw-flex;

            .notification-count {
                position: relative;
                margin-top: 3px;
                margin-left: 5px;
            }
        }
    }
</style>
